import Vue from 'vue';
import noty from './noty.service';

export default {
    /* strings */
    async listStrings(clientId) {
        return (await Vue.http.post('/api/content/strings/list', { clientId })).data;
    },
    async getString(stringContentId) {
        return (await Vue.http.get(`/api/content/strings/get/${stringContentId}`)).data;
    },
    async createString(stringContent) {
        let c = (await Vue.http.post('/api/content/strings/create', stringContent)).data;
        noty.success(`String content '${c.name}' craeted successfully`);
        return c;
    },
    async updateString(stringContent) {
        let c = (await Vue.http.post('/api/content/strings/update', stringContent)).data;
        noty.success(`String content '${c.name}' updated successfully`);
        return c;
    },
    async deleteString(stringContentId) {
        let c = (await Vue.http.delete(`/api/content/strings/delete/${stringContentId}`)).data;
        noty.success(`String content ${stringContentId} deleted successfully`);
        return c;
    },

    /* links */
    async listLinks(clientId) {
        return (await Vue.http.post('/api/content/links/list', { clientId })).data;
    },
    async getLink(linkContentId) {
        return (await Vue.http.get(`/api/content/links/get/${linkContentId}`)).data;
    },
    async createLink(linkContent) {
        let c = (await Vue.http.post('/api/content/links/create', linkContent)).data;
        noty.success(`Link content '${c.name}' craeted successfully`);
        return c;
    },
    async updateLink(linkContent) {
        let c = (await Vue.http.post('/api/content/links/update', linkContent)).data;
        noty.success(`Link content '${c.name}' updated successfully`);
        return c;
    },
    async deleteLink(linkContentId) {
        let c = (await Vue.http.delete(`/api/content/links/delete/${linkContentId}`)).data;
        noty.success(`Link content ${linkContentId} deleted successfully`);
        return c;
    }
};



// WEBPACK FOOTER //
// ./src/services/content.service.js